import { i18n } from "..";

export enum LongestTripDurationEnum {
  LESS_THAN_THREE_MONTHS = 'less_than_three_months',
  MORE_THAN_THREE_MONTHS = 'more_than_three_months',
}


export const LongestTripDurationEnumLabel = {
  [LongestTripDurationEnum.LESS_THAN_THREE_MONTHS]: i18n.t('common.constants.longestTripDuration.lessThanThreeMonths'),
  [LongestTripDurationEnum.MORE_THAN_THREE_MONTHS]: i18n.t('common.constants.longestTripDuration.moreThanThreeMonths'),
}